import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyACIjqaQKMV_NdVKNjE21csDsHEQl86cH4',
    },
})
